import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a9a96da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "priceshow__contact-widget" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, " Kannst Du Dich nicht entscheiden oder hast Du eine Frage? ", -1))
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  href: "tel:+498001332331",
  target: "_blank"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " (Mo.-Fr. 07-19 Uhr, Sa. 08-16 Uhr) ", -1))

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPhone } from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceshowContactWidget',
  setup(__props) {

library.add(faPhone);

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BaseSpacer),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(" Wir sind gern für Dich da:"),
      _hoisted_4,
      _createElementVNode("a", _hoisted_5, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-phone" }),
        _createTextVNode(" 0800 133 233 1 ")
      ]),
      _hoisted_6,
      _hoisted_7
    ])
  ]))
}
}

})